// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { Authenticated } from '../auth';
import ReceivedFaxPage from './ReceivedFax/ReceivedFaxPage';

export default {
  path: 'fax',
  name: 'Fax',
  component: Authenticated,
  childRoutes: [
    {
      path: 'received',
      name: 'ReceivedFax',
      component: ReceivedFaxPage,
    },
  ],
};
